// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const PopoverBody = createStyle({
  p: '$4',
  pt: '$2',
});
